import {
  InformalFeedbackReviewDismissReason,
  InformalFeedbackReviewScore,
} from 'api/clients/InformalFeedbackRequestsClient'
import { Dismissed, Feedback, Rejected } from 'blaze-ui/icons/20'
import { Approved } from 'blaze-ui/icons/24'
import { ReactNode } from 'react'

type ReviewResult = {
  iconSmall: ReactNode
  iconLarge: ReactNode
  label: string
  color: string
}

export const reviewResult: { [key: string]: ReviewResult } = {
  [InformalFeedbackReviewScore.Approved]: {
    iconSmall: <Approved size={20} />,
    iconLarge: <Approved />,
    label: 'Approved',
    color: 'var(--green-70)',
  },
  [InformalFeedbackReviewScore.NeedsMajorChanges]: {
    iconSmall: <Rejected />,
    iconLarge: <Rejected size={24} />,
    label: 'Sent back',
    color: 'var(--red-70)',
  },
  [InformalFeedbackReviewScore.NeedsChanges]: {
    iconSmall: <Feedback />,
    iconLarge: <Feedback size={24} />,
    label: 'Left feedback',
    color: 'var(--yellow-90)',
  },
  [InformalFeedbackReviewDismissReason.Declined]: {
    iconSmall: <Dismissed />,
    iconLarge: <Dismissed size={24} />,
    label: 'Did not review',
    color: 'var(--dark-60)',
  },
}
